import React from "react";
import Works from "./Works";
import "./portfolio.css";

const Porfolio = () => {
  return (
    <section className="work__section" id="portfolio">
      <h2 className="section__title">Portfolio</h2>
      <span className="section__subtitle">My Recent Works</span>
      <Works />
    </section>
  );
};

export default Porfolio;
